// src/pages/t-landing/common/const.js
import SwapBatteryCardInfo from '../components/swap-battery-card-info.vue';
import SwapBatteryButton from '../components/swap-battery-button.vue';

export const JUMP_URL_SOURCES = {
  bikeHome: 'hellobike://hellobike.com/app/home', // 哈啰单车-首页
};

// === 场景类型 ===
export const SCENE_TYPE = {
  HA_SWAP_BATTERY: 'HA_SWAP_BATTERY', // 小哈换电场景
};

// === 组件映射 ===
export const COMPONENT_MAP = {
  [SCENE_TYPE.HA_SWAP_BATTERY]: SwapBatteryCardInfo,
};

// === 按钮映射（未签约） ===
export const BUTTON_MAP = {
  [SCENE_TYPE.HA_SWAP_BATTERY]: SwapBatteryButton,
};

// === 充值类型 ===
export const CHARGE_TYPE = {
  HA_SWAP_PAY_AND_SIGN: 1310, // 抖音签约并支付
};

// === 订单类型 ===
export const ORDER_TYPE = {
  NORMAL: 0, // 普通订单
};

// === 行为类型 ===
export const ACTION_TYPE = {
  [SCENE_TYPE.HA_SWAP_BATTERY]: 9, // 换电套餐激活
};

// === 卡片类型 ===
export const CARD_TYPE = {
  [SCENE_TYPE.HA_SWAP_BATTERY]: 'batteryReplacement', // 换电卡
};

// === businessType ===
export const BUSINESS_TYPE = {
  [SCENE_TYPE.HA_SWAP_BATTERY]: 13, // 小哈换电需求
};

// === 错误码 ===
export const FAIL_CODE = 101; // 网络异常
export const LOW_VERSION_CODE = 301; // 版本过低

// === 兜底图片 ===
export const NET_IMG = 'https://m.hellobike.com/resource/gallery/919/YCU0e02t_wifi.png';
export const SIGN_IMG = 'https://m.hellobike.com/resource/gallery/919/vcF_2dFzpX.png';
export const LOW_VERSION_IMG = 'https://m.hellobike.com/resource/gallery/150/oUYIv3GO_Group%201707483917%20(1)%20(1).png?x-oss-process=image/quality,q_80';

// === TODO: 暂定配置 ===
export const MIN_APP_VERSION = '6.98.4';

// 页面版本过低时动态哈口令subScene请求参数
export const SUB_SCENE_MAP = {
  // 小哈换电场景配置
  [SCENE_TYPE.HA_SWAP_BATTERY]: {
    fat: '13',
    uat: '6',
    pro: '8',
  },
};

// 默认导出
export default {

};
